(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref99c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref99c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $60899288f4690e67$exports = {};
$parcel$extendImportMap({
    "4Ytyr": "screen-01.cce8aaf0.webp",
    gAljY: "screen-02.1be0ef59.webp",
    eziOm: "screen-03.ddfdfcef.webp",
    g71sp: "screen-04.3565a889.webp",
    caY5G: "screen-05.e3a796f5.webp",
    kOXvO: "screen-06.be016563.webp",
    "5iqW1": "screen-07.8f8e4168.webp",
    rVzQg: "screen-08.52ff19b9.webp",
    keKRk: "screen-09.ce65985f.webp",
    "8w4ch": "screen-10.e7211a90.webp",
    eS1fG: "screen-11.4bc3addc.webp",
    foBVk: "screen-12.8c0d389c.webp"
});

var $e053f9c6f418afb6$var$header = document.querySelector(".header");
window.addEventListener("scroll", function() {
    if (window.scrollY > 40) $e053f9c6f418afb6$var$header.classList.add("scrolled");
    else $e053f9c6f418afb6$var$header.classList.remove("scrolled");
});
var $e053f9c6f418afb6$var$experienceItems = document.querySelectorAll(".works__item");
$e053f9c6f418afb6$var$experienceItems.forEach(function(item) {
    var button = item.querySelector(".works__button");
    button.addEventListener("click", function() {
        var isActive = item.classList.contains("active");
        $e053f9c6f418afb6$var$experienceItems.forEach(function(el) {
            el.classList.remove("active");
        });
        if (!isActive) item.classList.add("active");
    });
});
var $e053f9c6f418afb6$var$slider = document.querySelector(".slider");
var $8bd1a6def43574db$exports = {};
$8bd1a6def43574db$exports = $parcel$resolve("4Ytyr");


var $bbf0e10bb7446f86$exports = {};
$bbf0e10bb7446f86$exports = $parcel$resolve("gAljY");


var $43222131d46978b8$exports = {};
$43222131d46978b8$exports = $parcel$resolve("eziOm");


var $7d0e0fb2790f6bf9$exports = {};
$7d0e0fb2790f6bf9$exports = $parcel$resolve("g71sp");


var $d23c1b636f6b8001$exports = {};
$d23c1b636f6b8001$exports = $parcel$resolve("caY5G");


var $aa1a20b8ad9d1fc1$exports = {};
$aa1a20b8ad9d1fc1$exports = $parcel$resolve("kOXvO");


var $707408412964b2a5$exports = {};
$707408412964b2a5$exports = $parcel$resolve("5iqW1");


var $e6ead20d79196d80$exports = {};
$e6ead20d79196d80$exports = $parcel$resolve("rVzQg");


var $760f988bf899a0b0$exports = {};
$760f988bf899a0b0$exports = $parcel$resolve("keKRk");


var $21a462addea44220$exports = {};
$21a462addea44220$exports = $parcel$resolve("8w4ch");


var $e10ecf66f59e5b5f$exports = {};
$e10ecf66f59e5b5f$exports = $parcel$resolve("eS1fG");


var $2d3e590b625dd344$exports = {};
$2d3e590b625dd344$exports = $parcel$resolve("foBVk");


if ($e053f9c6f418afb6$var$slider) {
    var $e053f9c6f418afb6$var$updateCounter = function updateCounter() {
        $e053f9c6f418afb6$var$current.textContent = String($e053f9c6f418afb6$var$currentIndex + 1).padStart(2, "0");
    };
    var $e053f9c6f418afb6$var$preloadImages = function preloadImages() {
        var nextIndex = ($e053f9c6f418afb6$var$currentIndex + 1) % $e053f9c6f418afb6$var$images.length;
        var prevIndex = ($e053f9c6f418afb6$var$currentIndex - 1 + $e053f9c6f418afb6$var$images.length) % $e053f9c6f418afb6$var$images.length;
        var next = new Image();
        next.src = $e053f9c6f418afb6$var$images[nextIndex];
        var prev = new Image();
        prev.src = $e053f9c6f418afb6$var$images[prevIndex];
    };
    var $e053f9c6f418afb6$var$changeSlide = function changeSlide(direction) {
        $e053f9c6f418afb6$var$animationId++;
        var currentAnimation = $e053f9c6f418afb6$var$animationId;
        $e053f9c6f418afb6$var$image.classList.remove("fade-in");
        $e053f9c6f418afb6$var$image.classList.add("fade-out");
        setTimeout(function() {
            if (currentAnimation !== $e053f9c6f418afb6$var$animationId) return;
            $e053f9c6f418afb6$var$currentIndex = ($e053f9c6f418afb6$var$currentIndex + direction + $e053f9c6f418afb6$var$images.length) % $e053f9c6f418afb6$var$images.length;
            $e053f9c6f418afb6$var$image.src = $e053f9c6f418afb6$var$images[$e053f9c6f418afb6$var$currentIndex];
            $e053f9c6f418afb6$var$updateCounter();
            $e053f9c6f418afb6$var$preloadImages();
            $e053f9c6f418afb6$var$image.classList.remove("fade-out");
            $e053f9c6f418afb6$var$image.classList.add("fade-in");
            setTimeout(function() {
                if (currentAnimation !== $e053f9c6f418afb6$var$animationId) return;
                $e053f9c6f418afb6$var$image.classList.remove("fade-in");
            }, 200);
        }, 100);
    };
    var $e053f9c6f418afb6$var$pointerDown = function pointerDown(x) {
        $e053f9c6f418afb6$var$startX = x;
        $e053f9c6f418afb6$var$currentX = x;
        $e053f9c6f418afb6$var$isPointerDown = true;
        $e053f9c6f418afb6$var$isDragging = false;
    };
    var $e053f9c6f418afb6$var$pointerMove = function pointerMove(x) {
        if (!$e053f9c6f418afb6$var$isPointerDown) return;
        $e053f9c6f418afb6$var$currentX = x;
        var delta = $e053f9c6f418afb6$var$currentX - $e053f9c6f418afb6$var$startX;
        if (Math.abs(delta) > 12) $e053f9c6f418afb6$var$isDragging = true;
    };
    var $e053f9c6f418afb6$var$pointerUp = function pointerUp() {
        if (!$e053f9c6f418afb6$var$isPointerDown) return;
        var delta = $e053f9c6f418afb6$var$currentX - $e053f9c6f418afb6$var$startX;
        if ($e053f9c6f418afb6$var$isDragging && Math.abs(delta) > $e053f9c6f418afb6$var$DRAG_DISTANCE) $e053f9c6f418afb6$var$changeSlide(delta < 0 ? 1 : -1);
        $e053f9c6f418afb6$var$isPointerDown = false;
        $e053f9c6f418afb6$var$isDragging = false;
    };
    var $e053f9c6f418afb6$var$image = $e053f9c6f418afb6$var$slider.querySelector(".slider__image");
    var $e053f9c6f418afb6$var$prevButton = $e053f9c6f418afb6$var$slider.querySelector(".slider__button--prev");
    var $e053f9c6f418afb6$var$nextButton = $e053f9c6f418afb6$var$slider.querySelector(".slider__button--next");
    var $e053f9c6f418afb6$var$current = $e053f9c6f418afb6$var$slider.querySelector(".slider__current");
    var $e053f9c6f418afb6$var$total = $e053f9c6f418afb6$var$slider.querySelector(".slider__total");
    var $e053f9c6f418afb6$var$images = [
        new URL($8bd1a6def43574db$exports).href,
        new URL($bbf0e10bb7446f86$exports).href,
        new URL($43222131d46978b8$exports).href,
        new URL($7d0e0fb2790f6bf9$exports).href,
        new URL($d23c1b636f6b8001$exports).href,
        new URL($aa1a20b8ad9d1fc1$exports).href,
        new URL($707408412964b2a5$exports).href,
        new URL($e6ead20d79196d80$exports).href,
        new URL($760f988bf899a0b0$exports).href,
        new URL($21a462addea44220$exports).href,
        new URL($e10ecf66f59e5b5f$exports).href,
        new URL($2d3e590b625dd344$exports).href
    ];
    console.log($e053f9c6f418afb6$var$images);
    var $e053f9c6f418afb6$var$currentIndex = 0;
    var $e053f9c6f418afb6$var$animationId = 0;
    $e053f9c6f418afb6$var$image.src = $e053f9c6f418afb6$var$images[0];
    $e053f9c6f418afb6$var$total.textContent = String($e053f9c6f418afb6$var$images.length).padStart(2, "0");
    $e053f9c6f418afb6$var$updateCounter();
    $e053f9c6f418afb6$var$preloadImages();
    $e053f9c6f418afb6$var$prevButton.addEventListener("click", function() {
        return $e053f9c6f418afb6$var$changeSlide(-1);
    });
    $e053f9c6f418afb6$var$nextButton.addEventListener("click", function() {
        return $e053f9c6f418afb6$var$changeSlide(1);
    });
    document.addEventListener("keydown", function(event) {
        if (event.key === "ArrowLeft") $e053f9c6f418afb6$var$changeSlide(-1);
        if (event.key === "ArrowRight") $e053f9c6f418afb6$var$changeSlide(1);
    });
    var $e053f9c6f418afb6$var$startX = 0;
    var $e053f9c6f418afb6$var$currentX = 0;
    var $e053f9c6f418afb6$var$isDragging = false;
    var $e053f9c6f418afb6$var$isPointerDown = false;
    var $e053f9c6f418afb6$var$DRAG_DISTANCE = 90;
    $e053f9c6f418afb6$var$image.addEventListener("mousedown", function(event) {
        event.preventDefault();
        $e053f9c6f418afb6$var$pointerDown(event.clientX);
    });
    window.addEventListener("mousemove", function(event) {
        $e053f9c6f418afb6$var$pointerMove(event.clientX);
    });
    window.addEventListener("mouseup", function() {
        $e053f9c6f418afb6$var$pointerUp();
    });
    $e053f9c6f418afb6$var$image.addEventListener("touchstart", function(event) {
        if (event.touches.length !== 1 || window.visualViewport.scale > 1) return;
        $e053f9c6f418afb6$var$pointerDown(event.touches[0].clientX);
    }, {
        passive: true
    });
    $e053f9c6f418afb6$var$image.addEventListener("touchmove", function(event) {
        if (event.touches.length !== 1 || window.visualViewport.scale > 1) return;
        $e053f9c6f418afb6$var$pointerMove(event.touches[0].clientX);
    }, {
        passive: true
    });
    $e053f9c6f418afb6$var$image.addEventListener("touchend", function() {
        $e053f9c6f418afb6$var$pointerUp();
    }, {
        passive: true
    });
}
var $e053f9c6f418afb6$var$footer = document.querySelector(".footer");
// Только устройства с сенсорным экраном (iPhone, Android, iPad)
var $e053f9c6f418afb6$var$isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
if ($e053f9c6f418afb6$var$footer && $e053f9c6f418afb6$var$isTouchDevice) {
    var $e053f9c6f418afb6$var$updateBackground = function updateBackground() {
        var rect = $e053f9c6f418afb6$var$footer.getBoundingClientRect();
        // Если верх футера находится в пределах экрана,
        // делаем фон body черным.
        var isFooterVisible = rect.top < window.innerHeight;
        document.body.classList.toggle("footer-visible", isFooterVisible);
    };
    window.addEventListener("scroll", $e053f9c6f418afb6$var$updateBackground, {
        passive: true
    });
    window.addEventListener("resize", $e053f9c6f418afb6$var$updateBackground);
    $e053f9c6f418afb6$var$updateBackground();
}

})();
//# sourceMappingURL=orbitalis.6f45cbbe.js.map
